export default __webpack_public_path__ + "content/6ecea4826b87fafb97be19edfa667a31.ttf";